import {useCallback, useSyncExternalStore} from 'react'

import {getActivationTraceIdSnapshot, subscribeToActivationTraceId} from '../ahp/activation-trace'

export function useActivationTraceId(taskId: string | undefined): string {
  const subscribe = useCallback((listener: () => void) => subscribeToActivationTraceId(taskId, listener), [taskId])
  const getSnapshot = useCallback(() => getActivationTraceIdSnapshot(taskId), [taskId])

  return useSyncExternalStore(subscribe, getSnapshot, () => '')
}
